<template>
  <v-container fluid fill-height class="ob-container">
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card class="ob-login ob-new-account elevation-10 ob-rounded-corners">
          <v-card-title>
            <v-layout column>
              <v-flex d-flex>
                <v-spacer></v-spacer>
                <v-btn icon color="error" flat style="flex: 0 0 auto !important" @click="emitEvent('close-inregistrare')">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-flex>
              <v-flex d-flex>
                <v-spacer></v-spacer>
                <h2 class="text-xs-center accent--text text--darken-2 display-1 font-weight-light">
                  INREGISTREAZA CONT
                </h2>
                <v-spacer></v-spacer>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-divider class="mt-4 mb-4"></v-divider>
          <v-card-text>
            <v-scroll-x-transition group hide-on-leave>
              <v-card class="elevation-0 ob-no-bg-color" v-if="sectiune === 1" :key="1">
                <v-card-title>
                  <h3 class="secondary--text headline font-weight-light">
                    {{sections[0].label}}
                  </h3>
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    prepend-icon="mdi-account-circle"
                    label="Nume"
                    v-model="user.nume"
                    clearable
                    clear-icon="mdi-close-circle"
                    :loading="!!(user.nume && user.nume.length)"
                    :rules="rules.nume">
                    <v-scroll-x-transition slot="append-outer" leave-absolute v-if="user.nume" appear>
                      <v-icon v-if="user.nume && user.nume.length >= 3" key="ok" color="success">mdi-check-circle</v-icon>
                      <v-icon v-else key="notok" color="error">mdi-alert-decagram</v-icon>
                    </v-scroll-x-transition>
                    <v-progress-linear
                      height="2"
                      slot="progress"
                      :value="Math.min(100, (user.nume && user.nume.length || 0) * 10)"
                      :color="['error', 'warning', 'success'][Math.floor(Math.min(100, (user.nume && user.nume.length || 0) * 10) / 40)]">
                    </v-progress-linear>
                  </v-text-field>
                  <v-text-field
                    prepend-icon="mdi-account-circle"
                    label="Prenume"
                    v-model="user.prenume"
                    clearable
                    clear-icon="mdi-close-circle">
                    <v-scroll-x-transition slot="append-outer" leave-absolute v-if="user.prenume" appear>
                      <v-icon v-if="user.prenume && user.prenume.length >= 3" key="ok" color="success">mdi-check-circle</v-icon>
                      <v-icon v-else key="notok" color="error">mdi-alert-decagram</v-icon>
                    </v-scroll-x-transition>
                  </v-text-field>
                  <v-text-field
                    prepend-icon="mdi-bank"
                    label="ID Institutie"
                    v-model="user.institutie"
                    clearable
                    clear-icon="mdi-close-circle">
                    <v-tooltip top slot="append" light color="transparent" max-width="300">
                      <v-icon slot="activator">mdi-alert-circle-outline</v-icon>
                      <v-alert value="true" type="info" color="primary">
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. A mollitia dolore tempora, placeat id qui vero necessitatibus sint, cupiditate nisi consectetur cumque repellat. Quos, atque illo porro ratione dolorum omnis?
                      </v-alert>
                    </v-tooltip>
                    <v-scroll-x-transition slot="append-outer" leave-absolute v-if="user.institutie" appear>
                      <v-icon v-if="user.institutie && user.institutie.length >= 3" key="ok" color="success">mdi-check-circle</v-icon>
                      <v-icon v-else key="notok" color="error">mdi-alert-decagram</v-icon>
                    </v-scroll-x-transition>
                  </v-text-field>

                </v-card-text>
                <v-card-actions class="mt-5">
                  <v-btn color="accent" flat v-if="sectiune > 1" @click="goToSection(-1)">
                    <v-icon left>mdi-arrow-left-bold-circle</v-icon>
                    {{sections[sectiune - 1 - 1].label}}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="accent" flat v-if="sectiune < 3" @click="goToSection(1)">
                    {{sections[sectiune].label}}
                    <v-icon right>mdi-arrow-right-bold-circle</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
              <v-card class="elevation-0 ob-no-bg-color" v-if="sectiune === 2" :key="2">
                <v-card-title>
                  <h3 class="secondary--text headline font-weight-light">
                    {{sections[1].label}}
                  </h3>
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    prepend-icon="mdi-account-card-details"
                    hide-details
                    label="Functie">
                  </v-text-field>
                  <v-text-field
                    prepend-icon="mdi-account-card-details"
                    hide-details
                    label="Departament">
                  </v-text-field>
                  <v-text-field
                    prepend-icon="mdi-email"
                    hide-details
                    label="E-mail">
                  </v-text-field>

                </v-card-text>
                <v-card-actions class="mt-5">
                  <v-btn color="accent" flat v-if="sectiune > 1" @click="goToSection(-1)">
                    <v-icon left>mdi-arrow-left-bold-circle</v-icon>
                    {{sections[sectiune - 1 - 1].label}}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="accent" flat v-if="sectiune < 3" @click="goToSection(1)">
                    {{sections[sectiune].label}}
                    <v-icon right>mdi-arrow-right-bold-circle</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
              <v-card class="elevation-0 ob-no-bg-color" v-if="sectiune === 3" :key="3">
                <v-card-title>
                  <h3 class="secondary--text headline font-weight-light">
                    {{sections[2].label}}
                  </h3>
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    prepend-icon="mdi-textbox"
                    hide-details
                    type="text"
                    label="Nume utilizator">
                  </v-text-field>
                  <v-text-field
                    prepend-icon="mdi-textbox-password"
                    hide-details
                    type="password"
                    label="Parola">
                  </v-text-field>
                  <v-text-field
                    prepend-icon="mdi-textbox-password"
                    hide-details
                    type="password"
                    label="Confirmare parola">
                  </v-text-field>
                </v-card-text>
                <v-card-actions class="mt-5">
                  <v-btn color="accent" flat v-if="sectiune > 1" @click="goToSection(-1)">
                    <v-icon left>mdi-arrow-left-bold-circle</v-icon>
                    {{sections[sectiune - 1 - 1].label}}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="accent" v-if="sectiune === 3" @click="goToSection(1)">
                    Inregistrare
                    <v-icon right>mdi-send</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-scroll-x-transition>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-for="i in 3" :key="i" small icon flat @click="sectiune = i">
              <v-icon color="primary" small v-if="sectiune === i">
                mdi-radiobox-marked
              </v-icon>
              <v-icon color="error" small v-if="sectiune !== i && i === 2">
                mdi-close
              </v-icon>
              <v-icon color="primary" small v-if="sectiune < i && i !== 2">
                mdi-radiobox-blank
              </v-icon>
              <v-icon color="primary" small v-if="sectiune > i && i !== 2">
                mdi-check
              </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'inregistrare-cont',
  data: () => ({
    sectiune: 1,
    user: {
      nume: null,
      prenume: 'An',
      institutie: null,
      functie: null,
      departament: null,
      email: null,
      parola: null,
      parola2: null
    },
    sections: [
      { label: 'Date personale' },
      { label: 'Date profesionale' },
      { label: 'Date access' }
    ],
    rules: {
      nume: [
        value => !!(value && value.length) || 'Camp obligatoriu!'
      ],
      prenume: [
        value => !!(value && value.length) || 'Camp obligatoriu!'
      ],
      institutie: [
        value => !!(value && value.length) || 'Camp obligatoriu!'
      ],
      functie: [
        value => !!(value && value.length) || 'Camp obligatoriu!'
      ],
      departament: [
        value => !!(value && value.length) || 'Camp obligatoriu!'
      ],
      email: [
        value => !!(value && value.length) || 'Camp obligatoriu!'
      ],
      parola: [
        value => !!(value && value.length) || 'Camp obligatoriu!'
      ],
      parola2: [
        value => !!(value && value.length) || 'Camp obligatoriu!'
      ]
    }
  }),
  methods: {
    emitEvent (event) {
      this.$emit(event)
    },
    goToSection (dir) {
      this.sectiune += dir
      if (this.sectiune < 1) this.sectiune = 1
      if (this.sectiune > 3) this.sectiune = 3
    }
  }
}
</script>
